export const API_CONSTANTS = {
  EVO_AUTHENTICATION_BASE_URL:
    process.env.REACT_APP_EVO_AUTHENTICATION_BASE_URL,
  EVO_PORTAL_BASE_URL: process.env.REACT_APP_EVO_PORTAL_BASE_URL,
  LOGIN: "/portal/login",
  VALIDATE_BP_SITE_ID: "/Registration/ValidateBPSiteId",
  REVALIDATE_BP_SITE_ID: "/Registration/RevalidateBPSiteId",
  VALIDATE_LOGIN_OTP: "/portal/ValidateLoginCode",
  SET_PASSWORD: "/portal/UserSetPassword",
  GET_USER_INFO: "/User/GetUserInformation",
  USER_RESEND_CODE: "/portal/UserResendCode",
  RESEND_OTP: "/Otp/ResendOtp",
  GET_CLINIC_USER_DETAILS: "/Clinic/GetClinicUserDetails",
  UPDATE_CLINIC_USER_INFO: "/Clinic/UpdateClinicUserDetails",
  DELETE_CLINIC_LOGO: "/Clinic/RemoveClinicLogoUrl",
  FORGOT_PASSWORD_INITIALIZATION: "/portal/ForgotPasswordInitialization",
  VALIDATE_FORGOT_PASSWORD_OTP: "/portal/ValidateForgotPasswordCode",
  REFRESH_TOKEN: "/portal/refreshtoken",
  GET_PROVIDER_DATA: "/Clinic/GetGPUsers",
  GET_CLINIC_LICENSES: "/Clinic/GetCLinicLicenses",
  ASSIGN_PROVIDER: "/Clinic/AssignLicenseToUser",
  UNASSIGN_PROVIDER: "/Clinic/UnassignProvider",
  GET_DETAILS_BY_SUBSCRIPTION_ID:
    "/Registration/GetClinicUserDetailsFromChargebee?subscriptionId=",
  REGISTER_SET_PASSWORD: "/Registration/ApplicationUserSetPassword",
  SIGN_OUT: "/portal/UserSignOut",
  CREATE_PORTAL_SESSION: "/ChargeBee/CreatePortalSession",
  GET_LOGIN_TOKEN: "/portal/GenerateUserLoginToken",
  IS_BP_SITE_ID_VERIFIED: "/User/IsBpSiteIdVerified",
  GET_CLINIC_DETAILS: "/Registration/GetClinicDetails",
  CHANGE_PASSWORD: "/portal/ChangePassword",
  GET_ALL_CLINICS: "/Clinic/GetAllClinicDetails",
  GET_ALL_CLINIC_NAMES: "/Clinic/GetAllClinicNames",
  GET_COMMUNICATION_LOGS: "/CommunicationLogs/GetClinicCommunicationLogDetails",
  GET_COMMUNICATION_LOGS_HISTORY:
    "/CommunicationLogs/GetCommunicationLogHistory",
  RESEND_COMMUNICATIOM: "/CommunicationLogs/ResendCommunication",
  RESEND_USING_ALTERNATE_METHOD:
    "/CommunicationLogs/ResendUsingAlternateMethod",
  ADDRESS_BOOK_LAST_UPDATED_STATUS:
    "/Registration/AddressBookLastUpdatedStatus",
  PATIENT_BILLING_REPORTS_INFO: "/Reporting/RequestPatientBillingReportsInfo",
  GENERATE_REPORT: "/Reporting/GeneratePatientBillingReport",
  DOWNLOAD_REPORT: "/Reporting/RequestPatientBillingReport",
  GET_BP_COMMUNICATION_LOGS:
    "/BpCommunicationLogs/GetClinicBpCommunicationLogDetails",
  GET_BP_COMMUNICATION_LOGS_HISTORY:
    "/BpCommunicationLogs/GetBPCommunicationLogHistory",
  RETRY_UPLOAD_TO_BP: "/BpCommunicationLogs/RetryUploadToBp",
  GET_DOCUMENT_NAMES: "/CommunicationLogs/GetDocumentNames",
  GET_DRAFT_CARE_SERVICE_INFO: "/Reporting/RequestDraftCareServicesInfo",
  GENERATE_DRAFT_CARE_SERVICE_REPORT: "/Reporting/GenerateDraftCareServiceReport",
  DOWNLOAD_DRAFT_CARE_SERVICE_REPORT: "/Reporting/RequestDraftCareServiceReport",
};
